export default __webpack_public_path__ + "1b00baa5e7e62682401d2f7e4aefb4dd.png";